import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    try {
      this.element.open = sessionStorage.getItem('category-sidebar-filters') !== 'closed';
    } catch (_) { /* Keep the expanded default when browser storage is unavailable. */ }
  }

  remember() {
    try {
      sessionStorage.setItem('category-sidebar-filters', this.element.open ? 'open' : 'closed');
    } catch (_) { /* The native disclosure remains usable without storage. */ }
  }
}
